export function projectToPixels(markers, bounds, projection, zoom) {
    const scale = Math.pow(2, zoom);
    return markers
        .filter((marker) => bounds.contains(new google.maps.LatLng(marker.position.latitude, marker.position.longitude)))
        .map((marker) => {
        const world = projection.fromLatLngToPoint(new google.maps.LatLng(marker.position.latitude, marker.position.longitude));
        // It might be null on a corner case (quote from docs)
        // If the projection is unavailable or the latitude/longitude is not supported (e.g., if it's outside the valid range).
        if (!world)
            return null;
        return {
            marker,
            positionX: world.x * scale,
            positionY: world.y * scale,
        };
    })
        .filter((projectedMarker) => projectedMarker !== null);
}
